import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { 
  BookOpen, 
  Video, 
  Users, 
  Award,
  Calendar,
  Download,
  ArrowRight
} from 'lucide-react';

const EducationSection = ({ language, onRegister }) => {
  const { tt } = useLanguage();
  const translations = {
    ru: {
      title: 'Обучение трейдингу',
      subtitle: 'От новичка до профессионала - полный курс обучения торговле на финансовых рынках',
      sections: [
        {
          icon: BookOpen,
          title: 'Обучающие материалы',
          description: 'Более 100 статей и руководств по основам трейдинга, техническому и фундаментальному анализу',
          items: [
            'Основы торговли на финансовых рынках',
            'Технический анализ и индикаторы',
            'Управление рисками и капиталом',
            'Психология трейдинга'
          ]
        },
        {
          icon: Video,
          title: 'Видео курсы',
          description: 'Интерактивные видео уроки от профессиональных трейдеров и аналитиков',
          items: [
            'Базовый курс для начинающих',
            'Продвинутые стратегии торговли',
            'Анализ рыночных ситуаций',
            'Практические примеры сделок'
          ]
        },
        {
          icon: Users,
          title: 'Персональное обучение',
          description: 'Индивидуальные консультации с опытными трейдерами и аналитиками',
          items: [
            'Персональная стратегия торговли',
            'Анализ ваших сделок',
            'Рекомендации по улучшению',
            'Поддержка 24/7'
          ]
        },
        {
          icon: Calendar,
          title: 'Вебинары и события',
          description: 'Еженедельные вебинары, семинары и торговые конкурсы',
          items: [
            'Еженедельные аналитические обзоры',
            'Торговые стратегии в реальном времени',
            'Конкурсы с призовым фондом',
            'Q&A сессии с экспертами'
          ]
        }
      ],
      features: [
        {
          icon: Award,
          title: 'Сертификация',
          description: 'Получите официальный сертификат после прохождения курса'
        },
        {
          icon: Download,
          title: 'Материалы для скачивания',
          description: 'Электронные книги, чек-листы и торговые шаблоны'
        },
        {
          icon: Users,
          title: 'Сообщество трейдеров',
          description: 'Присоединяйтесь к комьюнити из 50,000+ активных трейдеров'
        }
      ],
      cta: {
        title: 'Начните обучение уже сегодня',
        description: 'Получите доступ ко всем обучающим материалам совершенно бесплатно',
        button: 'Начать обучение'
      }
    },
    en: {
      title: 'Trading Education',
      subtitle: 'From beginner to professional - complete course for trading on financial markets',
      sections: [
        {
          icon: BookOpen,
          title: 'Educational Materials',
          description: 'More than 100 articles and guides on trading basics, technical and fundamental analysis',
          items: [
            'Basics of financial markets trading',
            'Technical analysis and indicators',
            'Risk and capital management',
            'Trading psychology'
          ]
        },
        {
          icon: Video,
          title: 'Video Courses',
          description: 'Interactive video lessons from professional traders and analysts',
          items: [
            'Basic course for beginners',
            'Advanced trading strategies',
            'Market situation analysis',
            'Practical trade examples'
          ]
        },
        {
          icon: Users,
          title: 'Personal Training',
          description: 'Individual consultations with experienced traders and analysts',
          items: [
            'Personal trading strategy',
            'Analysis of your trades',
            'Improvement recommendations',
            '24/7 support'
          ]
        },
        {
          icon: Calendar,
          title: 'Webinars and Events',
          description: 'Weekly webinars, seminars and trading competitions',
          items: [
            'Weekly analytical reviews',
            'Real-time trading strategies',
            'Prize fund competitions',
            'Q&A sessions with experts'
          ]
        }
      ],
      features: [
        {
          icon: Award,
          title: 'Certification',
          description: 'Get official certificate after course completion'
        },
        {
          icon: Download,
          title: 'Downloadable Materials',
          description: 'E-books, checklists and trading templates'
        },
        {
          icon: Users,
          title: 'Traders Community',
          description: 'Join community of 50,000+ active traders'
        }
      ],
      cta: {
        title: 'Start learning today',
        description: 'Get access to all educational materials completely free',
        button: 'Start Learning'
      }
    },
    kk: {
      title: 'Трейдингті оқыту',
      subtitle: 'Жаңадан бастаушыдан кәсіпқойға дейін - қаржы нарықтарында сауда жасауға толық курс',
      sections: [
        {
          icon: BookOpen,
          title: 'Оқу материалдары',
          description: 'Трейдинг негіздері, техникалық және іргелі талдау бойынша 100-ден астам мақалалар мен нұсқаулар',
          items: [
            'Қаржы нарықтарында саудалаудың негіздері',
            'Техникалық талдау және индикаторлар',
            'Тәуекелдер мен капиталды басқару',
            'Трейдинг психологиясы'
          ]
        },
        {
          icon: Video,
          title: 'Бейне курстар',
          description: 'Кәсіби трейдерлер мен талдаушылардан интерактивті бейне сабақтар',
          items: [
            'Жаңадан бастаушыларға арналған базалық курс',
            'Жетілдірілген сауда стратегиялары',
            'Нарық жағдайын талдау',
            'Мәмілелердің практикалық мысалдары'
          ]
        },
        {
          icon: Users,
          title: 'Жеке оқыту',
          description: 'Тәжірибелі трейдерлер мен талдаушылармен жеке кеңестер',
          items: [
            'Жеке сауда стратегиясы',
            'Мәмілелеріңізді талдау',
            'Жақсарту бойынша ұсыныстар',
            '24/7 қолдау'
          ]
        },
        {
          icon: Calendar,
          title: 'Вебинарлар мен іс-шаралар',
          description: 'Апта сайынғы вебинарлар, семинарлар және сауда конкурстары',
          items: [
            'Апта сайынғы талдамалық шолулар',
            'Нақты уақыттағы сауда стратегиялары',
            'Жүлде қорымен конкурстар',
            'Сарапшылармен Q&A сессиялары'
          ]
        }
      ],
      features: [
        {
          icon: Award,
          title: 'Сертификаттау',
          description: 'Курстан өткеннен кейін ресми сертификат алыңыз'
        },
        {
          icon: Download,
          title: 'Жүктеуге арналған материалдар',
          description: 'Электронды кітаптар, тексеру тізімдері және сауда үлгілері'
        },
        {
          icon: Users,
          title: 'Трейдерлер қауымдастығы',
          description: '50,000+ белсенді трейдерлердің қауымдастығына қосылыңыз'
        }
      ],
      cta: {
        title: 'Оқытуды бүгіннен бастаңыз',
        description: 'Барлық оқу материалдарына толығымен тегін қол жеткізіңіз',
        button: 'Оқытуды бастау'
      }
    }
  };

  const t = translations[language] || translations['ru'];

  return (
    <div className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        {/* Main Sections */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {t.sections.map((section, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-gradient-to-r from-emerald-600 to-green-600 rounded-xl flex items-center justify-center">
                    <section.icon className="w-8 h-8 text-white" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-semibold text-gray-900 mb-3">
                    {section.title}
                  </h3>
                  <p className="text-gray-600 mb-4">
                    {section.description}
                  </p>
                  <ul className="space-y-2">
                    {section.items.map((item, itemIndex) => (
                      <li key={itemIndex} className="flex items-center text-gray-700">
                        <ArrowRight className="w-4 h-4 text-emerald-600 mr-2 flex-shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {t.features.map((feature, index) => (
            <div
              key={index}
              className="text-center p-6 rounded-xl border-2 border-gray-100 hover:border-emerald-200 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-16 h-16 bg-gradient-to-r from-emerald-600 to-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <feature.icon className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-emerald-600 to-green-600 rounded-2xl p-8 md:p-12 text-center">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t.cta.title}
          </h3>
          <p className="text-emerald-100 text-lg mb-8 max-w-2xl mx-auto">
            {t.cta.description}
          </p>
          <button 
            onClick={onRegister}
            className="px-8 py-4 bg-white text-emerald-600 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors shadow-lg hover:shadow-xl">
            {t.cta.button}
            <ArrowRight className="w-5 h-5 ml-2 inline" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default EducationSection;